export var TextBlockStyles;
(function (TextBlockStyles) {
    TextBlockStyles["paragraph"] = "unstyled";
    TextBlockStyles["h1"] = "header-one";
    TextBlockStyles["h2"] = "header-two";
    TextBlockStyles["h3"] = "header-three";
})(TextBlockStyles || (TextBlockStyles = {}));
export var ListStyles;
(function (ListStyles) {
    ListStyles["unorderedList"] = "unordered-list-item";
    ListStyles["orderedList"] = "ordered-list-item";
})(ListStyles || (ListStyles = {}));
export var InlineStyles;
(function (InlineStyles) {
    InlineStyles["unstyled"] = "unstyled";
    InlineStyles["bold"] = "BOLD";
    InlineStyles["italic"] = "ITALIC";
    InlineStyles["underline"] = "UNDERLINE";
    InlineStyles["strikethrough"] = "STRIKETHROUGH";
})(InlineStyles || (InlineStyles = {}));
export var AlignStyles;
(function (AlignStyles) {
    AlignStyles["alignLeft"] = "alignLeft";
    AlignStyles["alignRight"] = "alignRight";
    AlignStyles["alignCenter"] = "alignCenter";
    AlignStyles["alignJustify"] = "alignJustify";
})(AlignStyles || (AlignStyles = {}));
export var draftStyleMap = {
    'alignLeft': {
        display: 'inline-block',
        width: '100%',
        textAlign: 'left'
    },
    'alignCenter': {
        display: 'inline-block',
        width: '100%',
        textAlign: 'center'
    },
    'alignRight': {
        display: 'inline-block',
        width: '100%',
        textAlign: 'right'
    },
    'alignJustify': {
        display: 'inline-block',
        width: '100%',
        textAlign: 'justify'
    }
};
//# sourceMappingURL=textStyleConstants.js.map